import { useCallback, useEffect, useMemo, useState } from "react";

export const useOptions = (props) => {
  const { optionSelections, onSelectionChange, options, selectedValues } =
    props;

  const hasNullOrUndefined = Array.from(optionSelections.values()).some(
    (value) => value === null || value === undefined
  );
  const initialEnabledState = new Map(
    options.map((option, index) => [
      option.attribute_id,
      hasNullOrUndefined ? index === 0 : true,
    ])
  );

  // Memoize initialEnabledState to ensure it's only calculated once
  // const initialEnabledState = useMemo(() => {
  //   const hasNullOrUndefined = Array.from(optionSelections.values()).some(
  //     (value) => value === null || value === undefined
  //   );

  //   return new Map(
  //     options.map((option, index) => [
  //       option.attribute_id,
  //       hasNullOrUndefined ? index === 0 : true,
  //     ])
  //   );
  // }, [optionSelections, options]);
  const [enabledOptions, setEnabledOptions] = useState(() => {
    const hasNullOrUndefined = Array.from(optionSelections.values()).some(
      (value) => value === null || value === undefined
    );
    return new Map(
      options.map((option, index) => [
        option.attribute_id,
        hasNullOrUndefined ? index === 0 : true,
      ])
    );
  });

  // useEffect(() => {
  //   setEnabledOptions(initialEnabledState);
  // }, [initialEnabledState]);

  const handleSelectionChange = useCallback(
    (optionId, selection) => {
      if (onSelectionChange) {
        onSelectionChange(optionId, selection);

        const newEnabledOptions = new Map(enabledOptions);

        let enableNext = false;
        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          if (option.attribute_id == optionId) {
            enableNext = true;
            newEnabledOptions.set(option.attribute_id, true);
          } else if (enableNext === "remain") {
            newEnabledOptions.set(option.attribute_id, false);
            onSelectionChange(option.attribute_id, null);
          } else {
            if (enableNext) {
              newEnabledOptions.set(option.attribute_id, true);
              onSelectionChange(option.attribute_id, null);
              enableNext = "remain";
            } else {
              newEnabledOptions.set(option.attribute_id, true);
            }
          }
        }

        setEnabledOptions(newEnabledOptions);
      }
    },
    [onSelectionChange, enabledOptions, optionSelections, options]
  );

  return {
    handleSelectionChange,
    enabledOptions,
    optionSelections,
  };
};
